var hasRole = function (user, role) { var _a; return Boolean((_a = user.roles) === null || _a === void 0 ? void 0 : _a.includes(role)); };
export default hasRole;
